export const ENGLISH_ONLY_INPUT_REGEX = /^[\x00-\x7F\u2018\u2019\u201C\u201D\u2013\u2014\u2026\u2022\u2032\u2033\u2039\u203A\u00A9\u00AE\u2122\u00A0]*$/;

const Regex = {
  validateEmail: (val) => {
    // eslint-disable-next-line
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      val
    );
  },
  validateMobile: (val) => {
    return /^\+?\d{9,12}$/.test(val);
  },
  validateEnglishOnlyInput: (val = "") => {
    return ENGLISH_ONLY_INPUT_REGEX.test(val);
  },
};

export default Regex;
